// const LOS_SERVICE_CONTEXT = "loan-service";
const LOS_SERVICE_CONTEXT = "los";
const CORE_SERVICE_CONTEXT = "core";
const LMS_SERVICE_CONTEXT = "lms";
const AUTH_SERVICE_CONTEXT = "auth";

/* eslint-disable prettier/prettier */
export const endpoint = {
    BASE_URL_STAGING: window.location.host === "localhost:3000" ? "http://localhost:4000": window.location.origin,
    // Authentication / Authorization
    SIGN_IN: "/auth/oauth/token",
    FORGOT_PASSWORD: "auth/v1/oauth/user/changePassword",
    GET_OTP: "auth/v1/oauth/user/forgetPassword",
    LOGOUT: "auth/v1/oauth/user/logout",
    USER_DETAIL: "core/v1/admin/user/detail",
    REFRESH_TOKEN: "",
    FILE_UPLOAD: "loan-service/upload",
    SOCIAL_LOGIN: "/auth/oauth2/authorize/google",
    AUTH_LOGIN: "/auth/login/oauth2/code/google",
    RETAIN_TOKEN: "/auth/v1/oauth2/user/retain-token",
    APP_URL: "/app/url-link",
    LOGO_URL :"core/v1/link/logo-url",
    FEATURE_FLAG: "/app/feature-flag",
    FORGET_PASSWORD:"/auth/v1/oauth2/user/forgetPassword",
    RESET_PASSWORD:"/auth/v1/oauth2/user/changePassword",
    UI_RESTRICTION_FIND:"core/v1/ui/restriction/find?",
};
